export const spaceName = 'odModifier';

export interface ModifierSettings {
  editingId: number;
  selectedTab: 'information' | 'stock' | 'translation';
  selectedTranslatedLang: string;
  actionType: 'submit' | false;
  originalData: {
    originalInformation: any;
    originalStockInfo: any;
    originalTranslation: any;
  };
  currentData: {
    currentInformation: any;
    currentStockInfo: any;
    currentTranslation: any;
  };
  relationData: any;

  showRecurringStockModal: {
    show: boolean;
    key?: 'edit';
  };
  editingStock: number;
  activeStockTab: 'daily' | 'recurring';
}

export default {
  actionType: false,
  selectedTab: 'information',
  selectedTranslatedLang: 'en_AU',
  relationData: {},
  showRecurringStockModal: {
    show: false,
  },
  activeStockTab: 'daily',
} as ModifierSettings;
